var DEG_TO_RAD = Math.PI / 180;
var MAX_NUM = Number.MAX_VALUE;
var MIN_NUM = -Number.MAX_VALUE;

export { DEG_TO_RAD, MAX_NUM, MIN_NUM };


// WEBPACK FOOTER //
// ./node_modules/@progress/kendo-drawing/dist/es/util/constants.js